import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RangeDateScreenerFilterModel} from '../../modals/RangeDateScreenerFilterModel';
import {NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-range-date-select',
  templateUrl: './range-date-select.component.html',
  styleUrls: ['./range-date-select.component.scss'],
})
export class RangeDateSelectComponent implements OnInit{
  @Output() filterChanged: EventEmitter<RangeDateScreenerFilterModel> = new EventEmitter();
  @Input() dateRange: RangeDateScreenerFilterModel = new RangeDateScreenerFilterModel();
  validFromDate = true;
  validToDate = true;
  restricted = false;

  constructor(private config: NgbDatepickerConfig) {
    const current = new Date();
    this.config.maxDate = {
      year: current.getFullYear(), month:
        current.getMonth() + 1, day: current.getDate()
    };
  }

  ngOnInit(): void {
  }

  onFromDateChange(): void {
    // @ts-ignore
    this.dateRange.maxDate = this.config.maxDate;
    if (this.dateRange.ngbToDate){
      this.mouseDownOnToDate();
    }
    this.validateFromDate();
    if (this.validFromDate) {
      this.filterChanged.emit(this.dateRange);
    }
  }

  onToDateChange(): void {
    // @ts-ignore
    this.dateRange.maxDate = this.config.maxDate;
    this.validateToDate();
    if (this.validToDate) {
      this.filterChanged.emit(this.dateRange);
    }
  }

  keyUpOnFromDate(): void {
    this.validateFromDate();
    if (this.validFromDate){
      this.filterChanged.emit(this.dateRange);
    }
  }

  keyUpOnToDate(): void {
    this.validateToDate();
    if (this.validToDate){
      this.filterChanged.emit(this.dateRange);
    }
  }

  validateFromDate(): void{
    if (this.dateRange.ngbFromDate) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      const fromDate = new Date(this.dateRange.ngbFromDate.month + '/' + this.dateRange.ngbFromDate.day + '/' + this.dateRange.ngbFromDate.year);
      const dateStr = this.dateRange.ngbFromDate + '';
      let validDay = false;
      let validMonth = false;

      if (this.dateRange.ngbFromDate.month){
        validMonth = this.validMonth(this.dateRange.ngbFromDate.month);
      }
      if (this.dateRange.ngbFromDate.day || dateStr.split('-').length > 2) {
        validDay = (!isNaN(fromDate.getTime()));
      }
      const maxDate = new Date(this.config.maxDate.month + '/' + this.config.maxDate.day + '/' + this.config.maxDate.year);
      if (!isNaN(fromDate.getTime()) && !isNaN(maxDate.getTime())) {
        this.validFromDate = fromDate.getTime() <= maxDate.getTime();
        this.restricted = !this.validFromDate;
      }
      this.validFromDate = validDay && validMonth && this.validFromDate;
    }else{
      this.validFromDate = true;
    }
  }

  validateToDate(): void{
    if (this.dateRange.ngbToDate) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      const toDate = new Date(this.dateRange.ngbToDate.month + '/' + this.dateRange.ngbToDate.day + '/' + this.dateRange.ngbToDate.year);
      const maxDate = new Date(this.config.maxDate.month + '/' + this.config.maxDate.day + '/' + this.config.maxDate.year);
      const minDate = this.config.minDate
        ? new Date(this.config.minDate.month + '/' + this.config.minDate.day + '/' + this.config.minDate.year) : new Date();
      let validDay = false;
      let validMonth = false;

      const dateStr = this.dateRange.ngbToDate + '';
      if (this.dateRange.ngbToDate.month){
        validMonth = this.validMonth(this.dateRange.ngbToDate.month);
      }
      if (this.dateRange.ngbToDate.day || dateStr.split('-').length > 2) {
        validDay = (!isNaN(toDate.getTime()));
      }
      if (!isNaN(toDate.getTime()) && !isNaN(maxDate.getTime())) {
        this.validToDate = toDate.getTime() >= minDate.getTime() && toDate.getTime() <= maxDate.getTime();
      }
      this.validToDate = validDay && validMonth && this.validToDate;
    }else{
      this.validToDate = true;
    }
  }

  mouseDownOnFromDate(): void {
    // @ts-ignore
    this.config.minDate = undefined;
    this.dateRange.minDate = undefined;
  }

  mouseDownOnToDate(): void {
    if (this.dateRange.ngbFromDate) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      const fromDate = new Date(this.dateRange.ngbFromDate.month + '/' + this.dateRange.ngbFromDate.day + '/' + this.dateRange.ngbFromDate.year);
      this.config.minDate = {
        year: fromDate.getFullYear(), month:
          fromDate.getMonth() + 1, day: fromDate.getDate()
      };
      // @ts-ignore
      this.dateRange.minDate = this.config.minDate;
    }
  }

  focusOut(): void{
    if (!this.validFromDate){
      this.dateRange.ngbFromDate = undefined;
      this.validFromDate = true;
    }
    if (!this.validToDate){
      this.dateRange.ngbToDate = undefined;
      this.validToDate = true;
    }
  }

  validMonth(month: number): boolean{
    return (month > 0 && month <= 12);
  }
}
